/* eslint-disable prefer-destructuring */
// Development environment configuration fallbacks
// In production: public/env-config.js already populated by Docker
// In development: webpack replaces process.env with .env values

window.env = window.env || {};

// Populate window.env from process.env for development
const env = window.env;
env.REACT_APP_AUTH_ENDPOINT = (
  env.REACT_APP_AUTH_ENDPOINT || process.env.REACT_APP_AUTH_ENDPOINT
);
env.REACT_APP_INTAKE_ENDPOINT = (
  env.REACT_APP_INTAKE_ENDPOINT || process.env.REACT_APP_INTAKE_ENDPOINT
);
env.REACT_APP_MEDICAL_CONTENT_ENDPOINT = (
  env.REACT_APP_MEDICAL_CONTENT_ENDPOINT
  || process.env.REACT_APP_MEDICAL_CONTENT_ENDPOINT
);
env.REACT_APP_ROLLBAR_ACCESS_TOKEN = (
  env.REACT_APP_ROLLBAR_ACCESS_TOKEN || process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN
);
env.REACT_APP_ENV = env.REACT_APP_ENV || process.env.REACT_APP_ENV;
